import Vue from 'vue'
import { URL_CAPTCHA } from '@/constants/urls.js'
import { CAPTCHA, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CAPTCHA.STATE.IMAGE]: null,
  [CAPTCHA.STATE.CAPTCHA_ID]: null,
  [CAPTCHA.STATE.METHOD]: null
}

const actions = {
  async [CAPTCHA.ACTIONS.GET_CAPTCHA_IMAGE] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_CAPTCHA}/image?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(CAPTCHA.MUTATIONS.GET_CAPTCHA_IMAGE, resp.data)
  },
  async [CAPTCHA.ACTIONS.GET_CAPTCHA_METHOD] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_CAPTCHA}/method?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(CAPTCHA.MUTATIONS.GET_CAPTCHA_METHOD, resp.data)
  },
  async [CAPTCHA.ACTIONS.CLEAR_CAPTCHA_IMAGE] ({ commit }) {
    commit(CAPTCHA.MUTATIONS.CLEAR_CAPTCHA_IMAGE)
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [CAPTCHA.ACTIONS.CLEAR_CAPTCHA_METHOD] ({ commit }) {
    commit(CAPTCHA.MUTATIONS.CLEAR_CAPTCHA_METHOD)
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  }
}

const mutations = {
  [CAPTCHA.MUTATIONS.GET_CAPTCHA_IMAGE] (state, captcha) {
    state[CAPTCHA.STATE.IMAGE] = captcha.image
    state[CAPTCHA.STATE.CAPTCHA_ID] = captcha.captchaId
  },
  [CAPTCHA.MUTATIONS.GET_CAPTCHA_METHOD] (state, method) {
    state[CAPTCHA.STATE.METHOD] = method
  },
  [CAPTCHA.MUTATIONS.CLEAR_CAPTCHA_IMAGE] (state) {
    state[CAPTCHA.STATE.IMAGE] = null
    state[CAPTCHA.STATE.CAPTCHA_ID] = null
  },
  [CAPTCHA.MUTATIONS.CLEAR_CAPTCHA_METHOD] (state) {
    state[CAPTCHA.STATE.METHOD] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
